var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3C101",
    d: "M112.3,46.5c-6.6-23.3-29.4-41-54.2-38.1c-0.1-0.2-0.3-0.2-0.6-0.2c-22.6,2.4-41,18.8-47.8,40.1 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,67.6,6.7,75,8.8,82.1 c0.8,2.9,2,5.6,3.4,8.1c0,0.2,0.1,0.4,0.3,0.5c3.8,6.5,9.4,11.7,16,16c9.8,6.4,20.5,10.7,32.4,10.6c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4,25.3-8.7c9.9-6.2,17-14.6,20.6-25.7C115.1,70.9,115.6,58.2,112.3,46.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.2518,
    y1: 54.8797,
    x2: 112.0273,
    y2: 91.6945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09587042,
    style: {
      stopColor: "#856715"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2089,
    style: {
      stopColor: "#987615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5754,
    style: {
      stopColor: "#D7AA0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    style: {
      stopColor: "#F3C101"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M55.2,35.1L27,61.7L45.8,70l5.6,26.2l37.5,13.2c0.6-0.4,1.3-0.7,1.9-1.1c9.9-6.2,17-14.6,20.6-25.7 c2.8-8.7,3.8-18.1,2.7-27.2l-17.3-7.8L55.2,35.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M61.5,56.3c0,0,8.1-24.5-19.3-23.5c0,0-26.9,0.8-18.9,23.5 c0,0,1.9,9.9,18.9,8.8C42.1,65.1,58.2,66.1,61.5,56.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F3C101",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M27,44.9c0,0,9.1-11.4,21.8-6.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M92.7,70.5c0,0,19-11.4,0.6-26.2c0,0-18-14.6-25.5,4.7 c0,0-4.3,7.5,7.3,16.3C75.1,65.4,85,75.1,92.7,70.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F3C101",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M76.6,43.8c0,0,12.3-2.3,18,7.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M75.3,88.9c0,0,7.4-20.9-16.2-20.6c0,0-23.1,0.3-16.7,19.9 c0,0,1.5,8.5,16.1,7.9C58.4,96.1,72.3,97.3,75.3,88.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F3C101",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M45.8,78.5c0,0,8-9.7,18.8-5.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupinsIcon);
export default __webpack_public_path__ + "static/media/lupins_icon.25ecfe32875114cde7a9f2910111e7bf.svg";
export { ForwardRef as ReactComponent };